import { Skeleton } from 'antd';
import React from 'react';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

function LlmMapperAILoader({ text, stars }) {
  return (
    <div
      style={{
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: 500,
      }}
    >
      <Skeleton.Button
        active
        style={{
          width: 1000,
          height: 500,
        }}
      />
      <div
        style={{
          position: 'absolute',
          fontSize: '32px',
          fontWeight: 600,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          color: '#fff',
        }}
      >
        {stars && (
          <AutoAwesomeIcon
            fontSize="large"
            style={
              {
                // animation: 'icon-color-animation 3s linear infinite',
              }
            }
          />
        )}
        <span
          style={{
            // background: 'linear-gradient(90deg, #ff6ec4, #7873f5, #4edbca)',
            backgroundSize: '200% auto',
            WebkitBackgroundClip: 'text',
            backgroundClip: 'text',
            // color: 'transparent',
            // animation: 'gradient-animation 3s linear infinite',
            margin: '0 10px',
          }}
        >
          {text}
        </span>
        {stars && (
          <AutoAwesomeIcon
            fontSize="large"
            style={
              {
                // animation: 'icon-color-animation 3s linear infinite',
              }
            }
          />
        )}
      </div>

      <style>
        {`
        @keyframes gradient-animation {
          0% {
            background-position: 0% 50%;
          }
          100% {
            background-position: 200% 50%;
          }
        }

        @keyframes icon-color-animation {
          0% {
            color: #ff6ec4;
          }
          50% {
            color: #7873f5;
          }
          100% {
            color: #4edbca;
          }
        }
      `}
      </style>
    </div>
  );
}

export default LlmMapperAILoader;
